module.exports = __webpack_public_path__ + "static/media/fondo-pg.a2553285.png";